/**
 * `labor.device_session.page` wire values for Configuration (queue vs build-line job), matching Pre-Pack and Clamp QC.
 * Stored in Postgres as station `config` plus optional `job_key` (see `parseStationAndJobKey` in labor routes).
 */

/** Queue and non-job Configuration routes — not a clocked-in work surface. */
export const CONFIGURATION_LIST_LABOR_PAGE = "configuration";

const CONFIG_JOB_PREFIX = "config-job:";

export function configurationLaborPageKeyForBatchItem(batchItemId: number): string {
  return `${CONFIG_JOB_PREFIX}${batchItemId}`;
}

export function configurationLaborPageKeyForAlternateOrder(alternateOrderId: number): string {
  return `${CONFIG_JOB_PREFIX}alternate-order:${alternateOrderId}`;
}

export function configurationLaborPageKeyForAlternate(sku: string): string {
  const trimmed = sku.trim();
  return trimmed === "" ? `${CONFIG_JOB_PREFIX}alternate` : `${CONFIG_JOB_PREFIX}alternate:${trimmed}`;
}

export function configurationLaborExpectedPageFromPathname(pathname: string, search = ""): string {
  const buildMatch = pathname.match(/^\/manufacturing\/configuration\/build\/(\d+)/);
  if (buildMatch) {
    const batchItemId = Number.parseInt(buildMatch[1] ?? "", 10);
    if (Number.isFinite(batchItemId) && batchItemId > 0) {
      return configurationLaborPageKeyForBatchItem(batchItemId);
    }
  }
  if (pathname.startsWith("/manufacturing/configuration/alternate-order/")) {
    const alternateOrderId = Number.parseInt(pathname.split("/").pop() ?? "", 10);
    if (Number.isFinite(alternateOrderId) && alternateOrderId > 0) {
      return configurationLaborPageKeyForAlternateOrder(alternateOrderId);
    }
  }
  if (pathname.startsWith("/manufacturing/configuration/alternate")) {
    const sku = new URLSearchParams(search).get("sku")?.trim() ?? "";
    return configurationLaborPageKeyForAlternate(sku);
  }
  if (pathname.startsWith("/manufacturing/configuration")) {
    return CONFIGURATION_LIST_LABOR_PAGE;
  }
  return CONFIGURATION_LIST_LABOR_PAGE;
}
